import AxiosAPI from "./AxiosAPI";

export const fetchBrands = async () => {
  try {
    const response = await AxiosAPI.get(`/catalog/brands
    `);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteBrandDataApi = async (deleteBrandId) => {
  try {
    const response = await AxiosAPI.delete(`/catalog/brands/${deleteBrandId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const handleEditBrand = async (brandData) => {
  try {
    const response = await AxiosAPI.put(
      `/catalog/brands/${brandData.key}`,
      brandData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const handleAddBrand = async (brandData) => {
  try {
    const response = await AxiosAPI.post("/catalog/brands", brandData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
